import {DrugItemColumnsDef} from '@/modules/drug-catalog/components/table-columns'
import {DisplayColDef} from '@cypro/ui/types'
import {isDefined} from '@cypro/ui/utils'
import {chakra} from '@chakra-ui/react'
import {DrugCatalogItem} from '@cypro/engine/schema'
import {createColumnHelper} from '@tanstack/react-table'
import {useTranslate} from '@tolgee/react'
import {LuPencil} from 'react-icons/lu'
import {useNavigate} from '@tanstack/react-router'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {useCan} from '@/shared/hooks/use-permissions'

export const solutionsColumnsHelper = createColumnHelper<DrugCatalogItem>()

// type AccessorColumnDef = AccessorColDef<DrugCatalogItem>
type DisplayColumnDef = DisplayColDef<DrugCatalogItem>

export const SolutionsColumnsDef = {
  ...DrugItemColumnsDef,

  viewPage: (def?: DisplayColumnDef) =>
    solutionsColumnsHelper.display({
      id: 'view=page',
      header: () => {
        return null
      },
      cell: ({row}) => {
        const navigate = useNavigate()
        const canEdit = useCan('catalogue.manage')
        if (!canEdit) return null

        const linkProps = {
          to: '/configuration/drug-catalog/solutions/new',
          search: {solutionId: row.original.id},
        } as const

        function onKeyDown(e: React.KeyboardEvent) {
          if (e.code === 'Enter' || e.code === 'Space') {
            e.preventDefault()
            e.stopPropagation()
            navigate(linkProps)
          }
        }
        return (
          <LinkButton {...linkProps} variant="ghost" size="sm" onClick={e => e.stopPropagation()} onKeyDown={onKeyDown}>
            <LuPencil />{' '}
          </LinkButton>
        )
      },
      ...def,
    }),
  concentration: (def?: DisplayColumnDef) =>
    solutionsColumnsHelper.display({
      id: 'concentration',
      header: () => {
        const {t} = useTranslate('common')
        return <chakra.div width="100%">{t('concentration')}</chakra.div>
      },
      cell: ({row}) => {
        const concentrationValue = row.original.solutionDetails?.concentrationValue
        const concentrationUnit = row.original.solutionDetails?.concentrationUnit?.ucumCode
        if (!isDefined(concentrationValue) && !isDefined(concentrationUnit)) return null
        return (
          <chakra.div color="fg.muted">
            {concentrationValue}
            {concentrationUnit}
          </chakra.div>
        )
      },
      ...def,
    }),

  types: (def?: DisplayColumnDef) =>
    solutionsColumnsHelper.display({
      id: 'ty[es',
      header: () => {
        const {t} = useTranslate('common')
        return <chakra.div>{t('type')}</chakra.div>
      },
      cell: ({row}) => {
        if (!row.original.solutionDetails?.types?.length) return null
        return (
          <chakra.div color="fg.muted">
            {row.original.solutionDetails?.types.map(item => item.solutionType?.name).join(', ')}
          </chakra.div>
        )
      },
      ...def,
    }),
}
